import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const GET_PRODUCT_INFO_REQUEST = 'GET_PRODUCT_INFO_REQUEST';
export const GET_PRODUCT_INFO_SUCCESS = 'GET_PRODUCT_INFO_SUCCESS';
export const GET_PRODUCT_INFO_ERROR = 'GET_PRODUCT_INFO_ERROR';

export function getProductInfoAction(pids) {
	return { type: GET_PRODUCT_INFO_REQUEST, pids };
}

export function getProductInfoSuccessAction(pids, data, fromCache) {
	return { type: GET_PRODUCT_INFO_SUCCESS, pids, data, fromCache };
}

export function getProductInfoErrorAction(error) {
	return { type: GET_PRODUCT_INFO_ERROR, error };
}

export function fetchProductInfoAction(pids) {
	return (dispatch, getState) => {
		dispatch(getProductInfoAction(pids));

		const { productInfo } = getState();
		const pidsNotInHistory = pids.filter(pid => !productInfo[pid] || productInfo.ttl[pid] < new Date().getTime());
		if (pidsNotInHistory.length === 0) {
			return Promise.resolve(dispatch(getProductInfoSuccessAction(pids, { productInfo }, true)));
		}

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/2/discover/productInfo/0?pids=${pids.join(',')}`
			})
		).then(
			json => dispatch(getProductInfoSuccessAction(pids, json['RESPONSE'])),
			err => dispatch(getProductInfoErrorAction(err))
		);
	};
}
